import { createFileRoute } from '@tanstack/react-router';

import { CourseBrowse } from '@/module/Author/Course';

export const Route = createFileRoute('/_auth/author/_author/course/_course/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CourseBrowse />;
}
